/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import AboutAllContent from "../components/About/AboutAllContent";
import { useLenis } from "../components/SmoothScroll";
import { Helmet } from "react-helmet-async";

export default function AboutPage() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
    <>
      <Helmet>
        <title>About Citrus Diagnostic Center | Physician-Owned Imaging</title>
        <meta
          name="description"
          content="Who is Citrus Diagnostic Center? A physician-owned imaging center delivering advanced diagnostic radiology with precision, expertise and clinical clarity."
        />
        <meta
          name="keywords"
          content="medical imaging
diagnostic medical imaging
medical imaging center
center for medical imaging
Physician Owned imaging
advanced diagnostic radiology
"
        />
      </Helmet>
      <AboutAllContent />
      <div className="flex justify-center items-center">
        <div className="w-11/12 xl:w-4/5  md:mb-16 mb-8">
          <iframe
            title="Citrus Diagnostic Center Florida"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6985.813095337112!2d-82.591563!3d28.901124999999997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e841badd2a4091%3A0xeb4dead7dc4f5402!2sCitrus%20Diagnostic%20Center!5e0!3m2!1sen!2sin!4v1760678219616!5m2!1sen!2sin"
            className="w-full md:h-[450px] h-[300px]"
            height=""
            width="100%"
            allowFullScreen="true`"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>{" "}
      </div>
    </>
  );
}
